import closebtnImg from "../../../assets/images/close.png";
import styles from "./index.module.scss";
import { ratingsArray } from "../../../AppConstants/Constants";

const VideoSpeedController = ({
  isOpen,
  currentRate,
  updateRate,
  toggleSettings,
}) => {
  return (
    <div
      className={`${styles.modalContainer} ${
        isOpen ? styles.open : styles.close
      }`}
    >
      <div className={styles.box}>
        <>
          <h2>
            PlayBack Speed
            <img
              role="button"
              onClick={toggleSettings}
              src={closebtnImg}
              className={styles.closeIcon}
              alt=""
            />
          </h2>

          <div className={styles.sliderContainer}>
            <input
              type="range"
              min={ratingsArray[0].rate}
              max={ratingsArray[ratingsArray.length - 1].rate}
              step={Math.abs(ratingsArray[0].rate - ratingsArray[1].rate)}
              value={currentRate}
              onChange={(e) => updateRate(+e.target.value)}
            />
            <div className={styles.sliderTitleContainer}>
              {ratingsArray.map((item, index) => (
                <div
                  key={index}
                  style={{
                    marginVertical: 10,
                    color: currentRate === item.rate ? "#eb4547" : "#fff",
                  }}
                  className={styles.sliderTitle}
                  onClick={() => updateRate(item.rate)}
                >
                  <span className={styles.desktop}>{item.landscapeTitle}</span>
                  <span className={styles.mobile}>{item.title}</span>
                </div>
              ))}
            </div>
          </div>
        </>
      </div>
    </div>
  );
};

export default VideoSpeedController;
